"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * @param {string} wordId
 */
class WordNotFoundError extends client_library_1.ExtendableError {
    constructor(wordId) {
        super(`word: ${wordId} does not exist`);
        this.wordId = wordId;
    }
}
exports.default = WordNotFoundError;
//# sourceMappingURL=WordNotFoundError.js.map